<template>
	<div>
		<v-dialog v-model="fieldListDialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width class="pr-0">Select Field
	        			<v-spacer></v-spacer>
		        		<v-btn flat icon @click="fn_newField">
		        			<v-icon class="primary-color">add</v-icon>
		        		</v-btn>
	        		</v-subheader>

	        		<v-text-field  solo flat placeholder="Search" v-model="searchValue"></v-text-field>
	        	</v-card-title>
	        	<!-- <v-divider></v-divider> -->
		        <v-card-text full-height nopadding :class="{'no-items-list-card': !filteredItems.length}">
		        	<!-- <v-radio-group v-model="selectedField" right-align-radio>
			            <v-radio :label="item.name" :value="item.name" v-for="(item, index) in filteredItems" :key="index" @change="setFieldValue(item)">
			            </v-radio>
			        </v-radio-group> -->

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in filteredItems" :key="index" @click="setFieldValue(item)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.name}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item.name == selectedField">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>
			        	</v-list-tile>
			        </v-list>

			        <div class="display_msg" v-if="!filteredItems.length">No Items</div>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		          	<!-- <v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">ok</v-btn> -->
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['setFieldValue', 'getFieldData', 'isAccountGroup'],
		data(){
			return{
				fieldsItems:[],
				selectedField: null,
				fieldListDialog:false,
				searchValue:''
			}
		},
		methods:{
			openDialogWeb: function () {
				this.fn_getItems();
				let fieldData = this.getFieldData();
				// this.fieldData.name ? this.selectedField = this.fieldData.name : this.selectedField = null;
				fieldData.name ? this.selectedField = fieldData.name : this.selectedField = null;
				this.searchValue = '';
				this.fieldListDialog = true;
			},
			closeDialogWeb: function () {
				this.fieldListDialog = false;
			},
			fn_newField: function () {
				this.isAccountGroup ? this.$parent.backButtonPress = false : '';
				// this.$parent.fn_closeDialog();
				this.$router.push({path:'/fields/new', query:{tagId:this.guidWeb(), ls:1, account_group:this.isAccountGroup?1:0}});
			},
			fn_getItems: function () {
		        let filterObject = {};
		        filterObject.groupTypeId = 101;

		        let self = this;
		        this.getItems("FieldList", filterObject, 
		          {
		            onSuccess: function (response) {
		              console.log(response);
		              self.fieldsItems = JSON.parse(response);
		            },
		            onError: function (error) {
		              console.log(error);
		            }
		          }
		        )
		    },
		},
		computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        return this.fieldsItems.filter(item => {
		          let fieldName = item.name.toLowerCase();
		          return fieldName.match(searchText);
		        })
		      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fields/dialog_field_list.vue